import { Flex, omitProps } from 'roo-ui/components';
import styled from '@emotion/styled';
import { css } from '@emotion/core';
import PropTypes from 'prop-types';

const spacing = (props) => {
  const { spacing, theme } = props;
  const spacingPx = typeof spacing === 'number' ? theme.space[spacing] : spacing;
  return spacing
    ? css`
        margin-left: -${spacingPx};
        margin-right: -${spacingPx};
        & > * {
          margin-left: ${spacingPx};
          margin-right: ${spacingPx};
        }
      `
    : false;
};

const Row = styled(Flex, omitProps(['spacing']))`
  ${spacing}
`;

Row.displayName = 'Row';

Row.defaultProps = {
  justifyContent: 'space-between',
};

Row.propTypes = {
  spacing: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
};

export default Row;
